import React from 'react';
import useCurrentUser from '~/react-hooks/use-current-user';

export function ScaMandatePanel() {
  const user = useCurrentUser();
  return (
    <div className='max-w-[800px] flex flex-col gap-y-3 p-3 v2-text-neutral-900 rounded-md v2-bg-neutral-50'>
      <span className='text-base font-bold'>SCA Mandate</span>
      <span className='text-xs'>
        By continuing I the user [{`${user.email}`}] authorise Bonjoro to send
        instructions to the financial institution that issued my card to take
        payments from my card account in accordance with the terms of my
        agreement with you.
      </span>
    </div>
  );
}
